// src/components/navbar/SectionCard.jsx
import React from "react";
import { FaChevronDown } from "react-icons/fa";

const colorClasses = {
  sky: "from-sky-500/20 to-sky-900/40 border-sky-500/40",
  amber: "from-amber-500/20 to-amber-900/40 border-amber-500/40",
  emerald: "from-emerald-500/20 to-emerald-900/40 border-emerald-500/40",
  slate: "from-slate-500/20 to-slate-900/40 border-slate-500/40",
  cyan: "from-cyan-500/20 to-cyan-900/40 border-cyan-500/40",
  violet: "from-violet-500/20 to-violet-900/40 border-violet-500/40",
  rose: "from-rose-500/20 to-rose-900/40 border-rose-500/40",
};

const SectionCard = ({ section, open, onToggle, children }) => {
  const colorClass = colorClasses[section.color] || colorClasses.slate;
  const Icon = section.icon;

  return (
    <li className="pb-1">
      <button
        onClick={onToggle}
        className={`w-full flex flex-row-reverse items-center justify-between gap-3 px-3 py-3 rounded-2xl 
        text-right border bg-gradient-to-br ${colorClass}
        text-slate-50 shadow-[0_6px_18px_rgba(15,23,42,0.35)]
        transition-all duration-150 hover:shadow-[0_10px_26px_rgba(15,23,42,0.5)]`}
      >
        <div className="flex flex-row-reverse items-center gap-3">
          <span className="flex items-center justify-center w-9 h-9 rounded-2xl bg-slate-900/40 border border-white/10">
            <Icon size={18} />
          </span>
          <div className="flex flex-col items-end">
            <span className="font-medium text-sm">{section.label}</span>
            {section.description && (
              <span className="text-[0.7rem] text-slate-200/70">
                {section.description}
              </span>
            )}
          </div>
        </div>
        <FaChevronDown
          className={`text-xs text-slate-100 transition-transform duration-150 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        className={`transition-all duration-200 origin-top ${
          open
            ? "max-h-[900px] opacity-100 mt-2"
            : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        {children}
      </div>
    </li>
  );
};

export default SectionCard;
